import React from 'react';

import styled, { css } from 'styled-components';

const LayoutCenter = styled.div(
  ({ theme }) => css`
    display: flex;
    justify-content: center;
  `
);

const Layout = styled.div(
  ({ theme }) => css`
    width: 100%;
    ${theme.breakpoint('xl')} {
      max-width: 1016px;
    }
  `
);

const LayoutGral = ({ children }) => (
  <LayoutCenter>
    <Layout>{children}</Layout>
  </LayoutCenter>
);

export default LayoutGral;
